import "./src/styles/main.scss"

export const onInitialClientRender = () => {
  // Lazy load Hotjar
  const loadHotjar = () => {
    if (window.hj) return
    ;(function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          ;(h.hj.q = h.hj.q || []).push(arguments)
        }
      h._hjSettings = { hjid: 5152799, hjsv: 6 }
      a = o.getElementsByTagName("head")[0]
      r = o.createElement("script")
      r.async = 1
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
      a.appendChild(r)
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=")
    console.log("Hotjar loaded")
  }

  // Lazy load GTM (gtag.js)
  const loadGTM = () => {
    if (window.gtagDidInit) return
    window.gtagDidInit = true

    // Load gtag.js script
    const script = document.createElement("script")
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-E0DCB9ZYCX"
    script.async = true
    document.head.appendChild(script)

    // Initialize gtag
    window.dataLayer = window.dataLayer || []
    function gtag() {
      window.dataLayer.push(arguments)
    }
    gtag("js", new Date())
    gtag("config", "G-E0DCB9ZYCX", { anonymize_ip: true })

    console.log("GTM/gtag.js loaded")
  }

  const interactionHandler = () => {
    window.removeEventListener("scroll", interactionHandler)
    window.removeEventListener("click", interactionHandler)
    loadHotjar()
    loadGTM()
  }

  window.addEventListener("scroll", interactionHandler, { once: true })
  window.addEventListener("click", interactionHandler, { once: true })
}
